import React from 'react';
/** Personal Components */
import QuestionFillinchinese from './fillinchinese';           // 中文填空
import QuestionFillin from './fillin';                  // 填空
import QuestionSelect from './select';                  // 选择
import QuestionJudge from './judge';                    // 判断
import QuestionHollow from './hollow';                  // 图片挖空
import QuestionStep from './step';                      // 应用题
import QuestionPair from './pair';                      // 连线
import QuestionClassify from './classify';              // 分类
import QuestionVertical from './vertical';              // 竖式
import QuestionDelivery from './delivery';              // 脱式
import VerticalSecond from './verticalSecond';              // 竖式二期
import QuestionSudoku from './sudoku';
import Footer from './Footer'// 数独
import './style.less';                  // 数独
/** Personal Js */
import * as Types from '../../../utils/questionType';
const Exercise = (props) => {
    let data = props.data;
    if(props.errorAnswer){data.answer = props.errorAnswer}//题目检错页显示的是错的的答题答案

    let dataCopy = JSON.parse(JSON.stringify(data));

    // 题目信息字段转换（适配）
    let obj = transformField(dataCopy);

    // 如果是分步解题，需转换其子题的字段
    if (obj.type === Types.TYPE_SHOW_WORDPROBLEM) {
        obj.sub_list = [];
        dataCopy.sub_list.forEach(item => {
            const oldItem = JSON.parse(JSON.stringify(item));
            const newItem = transformField(oldItem);
            obj.sub_list.push(newItem);
        });
    }

    return returnExercise(obj, props)
};

/**
 * 题目信息统一字段
 * @param id            题目ID
 * @param stem          题干
 * @param answer        答案
 * @param explain       解析
 * @param type          题目类型
 * @param difficult     题目难度
 * @param item_list     选项：{code:'', item: ''}
 * @param knowledge     知识点
 * @param local         本地正确率
 * @param right         全国正确率
 * @param train         练习量
 * @param thisRight     本次评测正确率
 * @param score         分数
 * @param wrongAnswer   错误答案
 */
function transformField(info) {
    let obj = {
        id: info.question_id,
        stem: info.stem,
        answer: info.answer,
        explain: info.explain,
        type: info.type_show,
        difficulty: info.difficulty,
        knowledge: info.knowledge,
        local: info.local,
        train: info.train,
        number: info.number,
        right: info.right,
        rate: info.right_rate,

        thisRight: info.thisRight,
        score: info.score,
        wrongAnswer: info.wrongAnswer,
    };

    // 如果是选择题或分类题，选项字段也需要转换
    if (obj.type === Types.TYPE_SHOW_SELECT || obj.type === Types.TYPE_SHOW_MULTISELECT || obj.type === Types.TYPE_SHOW_CLASSIFY) {
        obj.item_list = [];
        info.items&&info.items.forEach(item => {
            obj.item_list.push({
                code: item.code,
                item: item.item
            });
        });
    }

    return Object.assign(info,obj);
}

/**
 * 获取题目
 * @param {Object} obj 题目信息
 * @param {Object} props 题目属性
 */
function returnExercise(obj, props) {
    let dom = <div className={'question-wrapper'} >
            <div className="question-content">
                <div className="question-order">
                    <p className="math_text"><span>{`${(props.num||0) + 1}.`}</span></p>
                </div>
                {/* 题目题干 */}
                <div className="question-stem">
                    <div style={{color:'red'}}>暂不支持该题型</div>
                </div>
            </div>
            <div className="question-footer">

                <div className="footer-show">
                    <Footer {...props} obj={obj} key={obj.id}>

                    </Footer>

                </div>
            </div>

    </div>
    switch (obj.type) {
        case Types.TYPE_SHOW_FILLIN_CHINESE:
            // 中文填空
            dom = <QuestionFillinchinese {...props} obj={obj} key={obj.id} />;
            break;
        case Types.TYPE_SHOW_FILLIN:
            // 填空
            dom = <QuestionFillin {...props} obj={obj} key={obj.id} />;
            break;
        case Types.TYPE_SHOW_SELECT:
            // 选择
            dom = <QuestionSelect {...props} obj={obj} key={obj.id} />;
            break;
        case Types.TYPE_SHOW_MULTISELECT:
            // 多选
            dom = <QuestionSelect {...props} obj={obj} key={obj.id} />;
            break;
        case Types.TYPE_SHOW_JUDGE:
            // 判断
            dom = <QuestionJudge {...props} obj={obj} key={obj.id} />;
            break;
        case Types.TYPE_SHOW_HOLLOW:
            // 图片挖空
            dom = <QuestionHollow {...props} obj={obj} key={obj.id} />;
            break;
        case Types.TYPE_SHOW_WORDPROBLEM:
            // 应用题
            dom = <QuestionStep {...props} obj={obj} key={obj.id} />;
            break;
        case Types.TYPE_SHOW_LIGATURE:
            // 连线
            dom = <QuestionPair {...props} obj={obj} key={obj.id} />;
            break;
        case Types.TYPE_SHOW_CLASSIFY:
            // 分类
            dom = <QuestionClassify {...props} obj={obj} key={obj.id} />;
            break;
        case Types.TYPE_SHOW_VERTICAL:
            // 竖式
            dom = <QuestionVertical {...props} obj={obj} key={obj.id} />;
            break;
        case Types.TYPE_VERTICAL_SECOND:
            // 竖式二期
            dom = <VerticalSecond {...props} obj={obj} key={obj.id} />;
            break;
        case Types.TYPE_SHOW_DELIVERY:
            // 脱式
            dom = <QuestionDelivery {...props} obj={obj} key={obj.id} />;
            break;
        case Types.TYPE_SHOW_SUDOKU:
            // 数独
            dom = <QuestionSudoku {...props} obj={obj} key={obj.id} />;
            break;
        default:
            break;
    }
    return dom;
}

export default Exercise;


// WEBPACK FOOTER //
// ./src/entry_question_editor/question/exercise/view.js